import { FormProvider, UseFormReturn, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// Import components
import Fields from './fields/Fields';
import { Loader } from 'components/elements';
import { InvoiceModalAgreements } from './InvoiceModalAgreements';
import { ModalCloseButton } from 'components/views/offer_configurator/components/common/modals/components/ModalCloseButton';

// Import styles
import { Form, ContentWrapper, Info, StyledButton } from './styles';
import { AntModalStyled, StyledTitle, ModalContent } from 'components/views/offer_configurator/components/common/modals/styles';

// Import types
import type { AgreementsType } from 'types/api/agreements';
import type { InvoiceFormValues } from 'helpers/validations/invoice';

type Props = {
	agreements: AgreementsType;
	isLoading: boolean;
	methods: UseFormReturn<InvoiceFormValues>;
	areAgreementsValid: boolean;
	onCancel?: VoidFunction;
	closeModal: VoidFunction;
	handleInvoiceSubmit: SubmitHandler<InvoiceFormValues>;
};

export const InvoiceModal = ({ agreements, isLoading, methods, areAgreementsValid, onCancel, closeModal, handleInvoiceSubmit }: Props) => {
	const { t } = useTranslation('payment');

	return (
		<AntModalStyled visible onCancel={onCancel} footer={null} closable={false} centered>
			<ModalCloseButton closeModal={closeModal} />

			<ModalContent maxWidth="76rem" gap={3.6}>
				<StyledTitle>{t('invoice_modal_title')}</StyledTitle>

				<FormProvider {...methods}>
					<ContentWrapper>
						<Form onSubmit={methods.handleSubmit(handleInvoiceSubmit)} id="invoice_agreement-form">
							<Fields />
						</Form>

						<Info>{t('invoice_info')}</Info>

						<InvoiceModalAgreements agreements={agreements} />

						<Info>{t('invoice_form_info')}</Info>

						<StyledButton type="submit" form="invoice_agreement-form" disabled={!areAgreementsValid} variant="primary" modifiers={['contained']}>
							{t('invoice_save_button')}
						</StyledButton>

						{isLoading && <Loader background={false} />}
					</ContentWrapper>
				</FormProvider>
			</ModalContent>
		</AntModalStyled>
	);
};
